(() => {
  const initialized = new WeakSet();

  function initialize() {
    document.querySelectorAll('.shopify_subscriptions_app_container').forEach((container) => {
      if (initialized.has(container)) return;
      initialized.add(container);
      const section = container.closest('.shopify-section');
      if (!section) return;
      const activeBlock = () => container.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
      const checkedOption = () => activeBlock()?.querySelector('input[type="radio"]:checked');
      let preferredPlan = checkedOption()?.dataset.sellingPlanId || null;
      let restoring = false;
      let queued = false;

      function updatePrices(option) {
        if (!option?.dataset.variantPrice) return;
        const price = option.dataset.variantPrice;
        const compare = option.dataset.variantCompareAtPrice || '';
        const onSale = Boolean(compare && compare !== price);
        section.querySelectorAll('product-price, .sticky-add-to-cart__price').forEach((display) => {
          const regular = display.querySelector('.price__regular');
          const sale = display.querySelector('.price__sale');
          if (!regular || !sale) return;
          const regularPrice = regular.querySelector('.price');
          const salePrice = sale.querySelector('.price-item--sale');
          const comparePrice = sale.querySelector('.compare-at-price');
          if (regularPrice) regularPrice.textContent = price;
          if (salePrice) salePrice.textContent = price;
          if (comparePrice) comparePrice.textContent = compare;
          regular.style.display = onSale ? 'none' : 'block';
          sale.style.display = onSale ? 'block' : 'none';
        });
      }

      function synchronize() {
        queued = false;
        const block = activeBlock();
        if (!block) return;
        if (preferredPlan) {
          const matchingPlan = [...block.querySelectorAll('input[data-radio-type="selling_plan"]')]
            .find((input) => input.dataset.sellingPlanId === preferredPlan && !input.disabled);
          if (matchingPlan && !matchingPlan.checked) {
            restoring = true;
            matchingPlan.click();
            restoring = false;
          }
        }
        updatePrices(checkedOption());
      }

      function queueSync() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(synchronize);
      }

      container.addEventListener('change', (event) => {
        const option = event.target;
        if (!(option instanceof HTMLInputElement) || !option.matches('input[data-radio-type]')) return;
        if (!restoring && event.isTrusted) preferredPlan = option.dataset.sellingPlanId || null;
        queueSync();
      });
      section.addEventListener('variant:selected', () => {
        preferredPlan = checkedOption()?.dataset.sellingPlanId || null;
      });
      section.addEventListener('variant:update', queueSync);
      new MutationObserver(queueSync).observe(container, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });
      queueSync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
